import { Component, Vue, Prop } from 'vue-property-decorator';
import Header from './ExpandRowHeader/header.vue';
import SendNotice from './ExpandSendNotice/send.notice.vue';
import Detail from './ExpandRowDetail/detail.vue';
import * as T_T from 'cryface';

@Component({
   components: {
      Header,
      SendNotice,
      Detail
   }
})
export default class ListingsTableExpand extends Vue {

   public title: string = 'ListingsTableExpand';

   public detailkeys: string[] = [
      'price',
      'status',
      'city',
      'instruction'
   ];

   public selectedSection: string = 'detail';

   @Prop()
   public row: any;

   public wrapWord(str: string) {
      return T_T.wordWrap(str, 10);
   }

   public callbackSectionSelector(index: string) {
      this.selectedSection = index;
   }
}
